import { createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';
import { RootState } from 'utils/redux/store/store';

// Estado inicial
const initialState = {
  Id: 0,
  Nombre: '',
  Apellido: '',
  Email: '',
  Password: '',
  RolId: 2,
  FechaNac: null,
  DescuentoAsignado: 0,
  Telefono: '',
  EsElenco: false,
  EsAlumno: false,
  TipoSocioId: 3,
  Talleres: [],
};

const editUsuarioSlice = createSlice({
  name: 'editUsuario',
  initialState,
  reducers: {
    setEditUsuario(state, action) {
      const { FechaNac, ...rest } = action.payload;
      Object.assign(state, {
        ...rest,
        FechaNac: FechaNac ? new Date(FechaNac).toISOString() : '',
      });
    },
    resetEditUsuario(state) {
      Object.assign(state, initialState);
    },
    guardarEditUsuario(state, action) {
      const { FechaNac, ...rest } = action.payload;
      Object.assign(state, {
        ...rest,
        FechaNac: FechaNac ? new Date(FechaNac).toISOString() : '',
      });
    },
  },
});

export const selectEditUsuario = createSelector(
  (state: RootState) => state.editUsuario,
  usuario => ({
    ...usuario,
    FechaNac: usuario.FechaNac,
  })
);

export const { setEditUsuario, resetEditUsuario, guardarEditUsuario } = editUsuarioSlice.actions;
export default editUsuarioSlice.reducer;
